var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      typeof _vm.governingDocumentID === 'string' ||
        typeof _vm.governingDocumentID === 'number' ||
        _vm.documentURL
    )?_c('span',[_c('button',{class:_vm.isprimary !== undefined && _vm.isprimary === true
          ? 'button is-primary is-small is-outline is-rounded'
          : 'button is-info is-light is-small is-outline is-rounded',attrs:{"title":_vm.tooltip},on:{"click":function($event){$event.preventDefault();return _vm.downloadPdf(_vm.governingDocumentID, _vm.documentURL)}}},[_vm._v(" Pdf ")])]):_c('span',[_vm._v("   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }